import React from 'react';

const OutgoingEmailPage = React.lazy(() => import('pages/OutgoingEmail/OutgoingEmailPage'));
export default [{ path: '/outgoing-email', exact: true, name: 'Cấu hình email gửi đi',
  function: 'SYS_APPCONFIG_VIEW', component: OutgoingEmailPage }];
